import { Pipe, PipeTransform, inject } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DateDurationPipe } from '@shared/pipes/date-duration.pipe';

@Pipe({
  name: 'mutedStationAlertsTooltip',
  standalone: true,
})
export class MutedStationAlertsTooltipPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly dateDurationPipe = inject(DateDurationPipe);

  transform(mutedUntil: string): string {
    let mutedUntilInfo: string;
    if (mutedUntil) {
      mutedUntilInfo = `${this.translateService.instant('ALERTING.IS_MUTED_BACK')}: ${this.dateDurationPipe.transform(moment().toISOString(), mutedUntil)}`;
    } else {
      mutedUntilInfo = `${this.translateService.instant('ALERTING.IS_MUTED_BACK_MANUALLY')}`;
    }
    return `${this.translateService.instant('ALERTING.MUTED_STATION')}.\n ${mutedUntilInfo}`;
  }
}
